export const WS_CONNECTION_START = "WS_CONNECTION_START";
export const WS_CONNECTION_SUCCESS = "WS_CONNECTION_SUCCESS";
export const WS_CONNECTION_ERROR = "WS_CONNECTION_ERROR";
export const WS_CONNECTION_CLOSED = "WS_CONNECTION_CLOSED";
export const WS_CONNECTION_CLOSE = "WS_CONNECTION_CLOSE";
export const WS_GET_MESSAGE = "WS_GET_MESSAGE";
export const WS_SEND_MESSAGE = "WS_SEND_MESSAGE";

export const WS_CONNECTION_START_AUTH = "WS_CONNECTION_START_AUTH";
export const WS_CONNECTION_SUCCESS_AUTH = "WS_CONNECTION_SUCCESS_AUTH";
export const WS_CONNECTION_ERROR_AUTH = "WS_CONNECTION_ERROR_AUTH";
export const WS_CONNECTION_CLOSED_AUTH = "WS_CONNECTION_CLOSED_AUTH";
export const WS_CONNECTION_CLOSE_AUTH = "WS_CONNECTION_CLOSE_AUTH";
export const WS_GET_MESSAGE_AUTH = "WS_GET_MESSAGE_AUTH";
export const WS_SEND_MESSAGE_AUTH = "WS_SEND_MESSAGE_AUTH";
